import { render, staticRenderFns } from "./ImportContactsFromFile.vue?vue&type=template&id=38f511f1"
import script from "./ImportContactsFromFile.vue?vue&type=script&lang=js"
export * from "./ImportContactsFromFile.vue?vue&type=script&lang=js"
import style0 from "./ImportContactsFromFile.vue?vue&type=style&index=0&id=38f511f1&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports